import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import Button from '../../../../components/elements/button';
import { AgGridReact } from 'ag-grid-react';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import { useCommonApi } from '../../../../store/api/hooks/commonApiHook';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { useCycleCountApi } from '../../../../store/api/hooks/cycleCountApiHook';
import toast from 'react-hot-toast';
import { getSelectedOption, showLocalDateTime } from '../../../../_common/functions';
import { useFacilityManagersSelector } from '../../../../store/selectors/masterSelector';
import { useWorkOrderApi } from '../../../../store/api/hooks/workOrderApiHook';
import { useAppLoader } from '../../../../_common/pageLoader/appLoaderHook';
import { useUserSelector } from '../../../../store/selectors/userSelector';
interface Props {
	_ref?: any;
	editData?: any;
	onCreate?: () => void;
	onCancel?: () => void;
	partDetails?: any;
}

type FormValues = {
	pickedByID: any;
	facilityID: any;
	subFacilityID: any;
	drop: DropdownOptionType;
	pickNote: any;
	purchaseDate: Date;
};

const yourConstant = 'someValue';

const CreateStockpicking: React.FC<Props> = ({
	_ref,
	editData,
	onCreate = () => { },
	onCancel = () => { },
	partDetails
}) => {
	const { control, register, handleSubmit, setValue, trigger, reset, watch, formState: { errors } } = useForm<FormValues>();

	const [facilityoption, setFacilityoption] = useState<any>(null);
	const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
	const [cycleCountCode, setCycleCountCode] = useState<any>(null);
	const [partstatus, setPartStatus] = useState<boolean>(false);
	const { showLoader, hideLoader } = useAppLoader();
	const [scanCode, setScanCode] = useState<string>('');
	const [parts, setParts] = useState<any>([]);
	const facilityApi: any = useFacilitiesApi();
	const commonApi: any = useCommonApi();
	const spearPartsAPI = useSpearPartsApi();
	const cycleCountAPI = useCycleCountApi();
	const workOrderAPI: any = useWorkOrderApi();

	const logedinuser: any = useUserSelector();
	const users = useFacilityManagersSelector();
	const facilityWatch = watch("facilityID");
	const subFacilityWatch = watch('subFacilityID');

	const getfacilitylist = () => {
		const payload = {};
		facilityApi.getFacilityList(
			payload,
			(resp: any) => {
				let facilitylist: any = [];
				resp.facilityList.map((facilist: any) => {
					facilitylist.push({
						label: facilist.facilityName,
						value: facilist.facilityID,
						data: facilist,
					});
				});
				setFacilityoption(facilitylist);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	const getsubfacilityList = (_facilityID: any) => {
		const payload = { facilityID: _facilityID };
		facilityApi.getSubFacilityList(
			payload,
			(resp: any) => {
				let subfacilityoption: any = resp?.subFacilityList?.map(
					(countylist: any) => {
						return {
							label: `${countylist.subFacilityTypeName} - ${countylist.no}`,
							value: countylist.subFacilityID,
						};
					}
				);
				setsubfacilityoption(subfacilityoption);

				if (editData) {
					setValue("subFacilityID", getSelectedOption(editData?.subFacilityID, subfacilityoption));
				}

			},
			(error: any) => {
				console.log("error =>", error);
				setsubfacilityoption([]);
				toast.error(error);
			}
		);
	};

	const getCycleCountCode = () => {
		const payload = {};
		cycleCountAPI.GetID(
			payload,
			(resp: any) => {

				setCycleCountCode(resp.code);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	useEffect(() => {
		if (users == null) {
			commonApi.GetUserList(
				{
					pageNo: 1,
					pageSize: 1000,
				},
				(resp: any) => { },
				(error: any) => { }
			);
		}
	}, [users]);

	useEffect(() => {
		if (facilityWatch) {
			setValue("subFacilityID", null);
			getsubfacilityList(facilityWatch.value);
		}
	}, [facilityWatch]);

	const formReset = () => {
		reset({



			facilityID: '',
			subFacilityID: ''

		});
		setParts([])
		setPartStatus(false)
	};

	useEffect(() => {
		if (_ref?.current) {
			_ref.current.reset = formReset;
		}
	}, [_ref]);
	const addScanCode = (code: string) => {
		spearPartsAPI.getSpearPartsList(
			{
				pageSize: 20,
				pageNumber: 1,
				searchParam: code,
			},
			(data: any) => {
				if (data?.sparePartsList?.length > 0) {
					let partOption = {
						label: data?.sparePartsList[0].sparePartsName + ` (${data?.sparePartsList[0].partsCode})`,
						value: data?.sparePartsList[0].partsID,
						partDetails: data?.sparePartsList[0],
					};

					cycleCountAPI.GetStockCount(
						{
							partID: partOption.value,
							facilityID: facilityWatch?.value,
							subFacilityID: subFacilityWatch?.value
						},
						(resp: any) => {
							let alreadyAdded = false;

							setParts(parts.map((part: any) => {
								if (part.partDetails?.partsCode == partOption.partDetails?.partsCode) {
									alreadyAdded = true
									return { ...part, qty: Number(part.qty) + 1 }
								} else {
									return part
								}
							}))
							if (!alreadyAdded) {
								setParts([
									...parts,
									{
										...partOption,
										currentStock: resp?.currentStock || 0,
										qty: 1
									},
								]);
							}
						},
						(error: any) => {
							setParts([...parts, { ...partOption, currentStock: 0 }]);
						}
					);
				} else {
					toast.error("No spare part found")
				}
			},
			(error: any) => {
				toast.error("No spare part found")
			}
		);
	}


	const onSubmit: SubmitHandler<FormValues> = data => {
		console.log(data);

		// Validate pick quantity doesn't exceed available quantity
		const exceeded = parts.find((part: any) => Number(part.qty) > part.currentStock);
		if (exceeded) {
			toast.error(`Pick quantity for "${exceeded.partDetails?.sparePartsName}" cannot exceed available quantity (${exceeded.currentStock}).`);
			return;
		}

		// "partsID": part.partDetails.partsID,
		//         "stockOnHand": part.currentStock,
		//         "adjustedQuantity": ((Number(part.in_stock??0)+Number(part.currentStock??0))-Number(part.out_stock??0)),
		//         "partsCostRate": part.partDetails.costPerUnit,
		//         "partsTotalAmount": ((Number(part.in_stock??0)+Number(part.currentStock??0))-Number(part.out_stock??0)) * parseFloat(part.partDetails.costPerUnit),
		//         "partsTotalAmountLocal": ((Number(part.in_stock??0)+Number(part.currentStock??0))-Number(part.out_stock??0)) * parseFloat(part.partDetails.costPerUnit),
		//         "exchangeRate": 1,
		//         "currencyID": 1,
		//         "unitID": part.partDetails.unitID

		let payload: any = [{
			facilityID: data?.facilityID?.value,
			subFacilityID: data?.subFacilityID?.value || null,
			pickNo: Date.now(), // or generate a unique pick number if needed
			pickingDate: new Date().toISOString(),
			pickedByID: data?.pickedByID?.value,
			pickNote: data.pickNote

			,

			stockPickDetails: parts.map((part: any) => {
				return {
					partsID: part.partDetails.partsID, // assuming partsID is available in part object
					pickQuantity: +part.qty, // assuming you want to pick the required quantity
					//partsCostRate: part.partDetails.costPerUnit || 0, // assuming you have a cost rate in the part object
					partsCostRate: part.partDetails.avgUnitCost || 0,
					//partsTotalAmount: ((part.partDetails.costPerUnit || 0) * part.qty), // calculate the total amount
					partsTotalAmount: ((part.partDetails.avgUnitCost || 0) * part.qty), // calculate the total amount
					unitID: part.partDetails.unitID || 0, // assuming you have unitID in the part object
				}
			})

		}]

		const payloadpicking: any = {}
		payloadpicking.request = payload

		console.log("payload", payload);
		showLoader();
		workOrderAPI.InsertStockPicking(
			payloadpicking,
			(resp: any) => {
				onCreate();
				onCancel();
				console.log(resp, "Submited resp")
				toast.success(resp?.message)
				formReset();
				hideLoader();
			},
			(error: any) => {
				console.log('error =>', error);
				hideLoader();
				toast.error(error);
			}
		);
	};

	useEffect(() => {
		getfacilitylist();
		// Set default picked by user to logged-in user
		if (logedinuser && logedinuser.hasOwnProperty(`userID`) && logedinuser.userID) {
			setValue(`pickedByID`, { label: (logedinuser.lastName + ` ` + logedinuser.firstName), value: logedinuser.userID });
		}
	}, []);

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<div className='pt-4'>
				<div className="grid grid-cols-2 gap-4">
					<div className='bg-green-50 py-2 px-3'>
						<h6 className='text-[0.813rem] font-semibold'>Pick No</h6>
						<p className='text-[0.813rem] font-normal mt-2'>{editData ? Date.now() : Date.now()}</p>
					</div>
					<div className='bg-green-50 py-2 px-3'>
						<h6 className='text-[0.813rem] font-semibold'>Date and Time</h6>
						{/* <p className='text-[0.813rem] font-normal mt-2'>{editData ? new Date().toISOString() : new Date().toISOString()}</p> */}
						<p className='text-[0.813rem] font-normal mt-2'>
							{editData ? showLocalDateTime(editData) : showLocalDateTime(new Date())}
						</p>
					</div>
				</div>
				<div className='grid grid-cols-2 gap-2'>
					<Controller
						name='pickedByID'
						control={control}
						rules={{ required: "Picked By is required" }}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label='Picked By'
								value={value}
								onChange={onChange}
								required
								placeholder='Picked By'
								options={users ? users : []}
								className='mb-0'
								error={errors.pickedByID?.message as any}
							/>
						)}
					/>


				</div>
				<Controller
					name="facilityID"
					control={control}
					rules={{ required: "Facility is required" }}
					render={({ field: { value, onChange } }) => (
						<SelectBox
							label="Select Facility"
							value={value}
							disabled={partstatus}
							onChange={onChange}
							required
							placeholder="Choose Facility"
							options={facilityoption}
							className="mb-0"
							error={errors.facilityID?.message as any}
						/>
					)}
				/>
				{/*
					<Controller
						name="subFacilityID"
						control={control}
						//  rules={{ required: "SubFacility is required" }}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Select Sub Facility"
								value={value}
								disabled={partstatus}
								onChange={onChange}
								//   required
								placeholder="Choose Sub Facility"
								options={subfacilitylist}
								className="mb-0"
							/>
						)}
					/>
					*/}

				<Button disabled={partstatus} className="mt-3" type="button"
					onClick={() => {
						trigger(['facilityID']).then((valid: boolean) => {
							if (valid) {
								setPartStatus(true);
								if (partDetails) {
									addScanCode(partDetails.partsCode)
								}
							}
						})
					}}
				>
					Start
				</Button>
				{partstatus && (
					<>
						{!partDetails && (
							<div>
								<Input
									className="!my-0"
									type="text"
									value={scanCode}
									onChange={(e: any) => {
										setScanCode(e.target.value)
									}}
									placeholder="Enter Part Code"
									onKeyDown={(e: any) => {
										if (e.key === "Enter") {
											e.preventDefault();
											if (e.target.value) {
												addScanCode(e.target.value);
												setScanCode('')
											}
										}
									}}
								/>
								<div className="text-center mt-2 font-normal text-slate-500">OR</div>
								<SelectBox
									className="mt-2"
									async={true}
									value={null}
									onChange={(option) => {
										console.log("fdsfsfsfsf", option);
										cycleCountAPI.GetStockCount(
											{
												partID: option.value,
												facilityID: facilityWatch?.value,
												subFacilityID: subFacilityWatch?.value
											},
											(resp: any) => {
												console.log("return arra--------", resp);


												let alreadyAdded = false;

												setParts(parts.map((part: any) => {
													if (part.partDetails?.partsCode == option.partDetails?.partsCode) {
														alreadyAdded = true;

														return { ...part, qty: Number(part.qty) + 1 }
													} else {
														return part
													}
												}))
												if (!alreadyAdded) {
													setParts([
														...parts,
														{
															...option,
															currentStock: resp?.currentStock || 0,
															qty: 1
														},
													]);
												}
											},
											(error: any) => {
												setParts([...parts, { ...option, currentStock: 0 }]);
											}
										);
									}}
									placeholder="search part here"
									asyncLoadOptions={(value: string) => {
										return new Promise((resolve, reject) => {
											spearPartsAPI.getSpearPartsList(
												{
													pageSize: 20,
													pageNumber: 1,
													searchParam: value,
												},
												(data: any) => {
													// console.log("Part Data", data)
													resolve(
														data.sparePartsList.map((part: any) => {
															return {
																label: part.sparePartsName + ` (${part.partsCode})`,
																value: part.partsID,
																partDetails: part,
															};
														})
													);
												},
												(error: any) => {
													reject(error);
												}
											);
										});
									}}
								/>
							</div>
						)}

						<div className="rounded-md border border-gray-300 mt-3">
							<div className="grid grid-cols-12 gap-1 bg-gray-100">
								<div className="col-span-3 px-2 leading-10 ">
									<label className="text-[0.75rem] font-medium text-slate-600">
										Part Code
									</label>
								</div>
								<div className="col-span-3 px-2 leading-10">
									<label className="text-[0.75rem] font-medium text-slate-600">
										Part Name
									</label>
								</div>
								<div className="col-span-3 px-2 leading-10">
									<label className="text-[0.75rem] font-medium text-slate-600">
										Available QTY
									</label>
								</div>
								<div className="col-span-3 px-2 leading-10">
									<label className="text-[0.75rem] font-medium text-slate-600">
										Pick  Qty
									</label>
								</div>
							</div>
							{parts.map((part: any, index: any) => (
								<div
									className="grid grid-cols-12 gap-1 text-slate-800"
									key={part.id}
								>
									<div className="col-span-3 px-2 leading-10 flex items-center">
										{part?.partDetails?.partsCode}
									</div>
									<div className="col-span-3 px-2 leading-10 flex items-center">
										<label className="text-[0.75rem] font-normal">
											{part?.partDetails?.sparePartsName}
										</label>
									</div>
									<div className="col-span-3 px-2 leading-10 flex items-center">
										<label className="text-[0.75rem] font-normal text-center w-full">
											{part?.currentStock}
										</label>
									</div>
									<div className="col-span-3 px-2 leading-10 flex items-center">
										<Input
											size="sm"
											className="!my-0"
											type="number"
											value={part.qty}
											onChange={(e) => {
												const value = Number(e.target.value);
												if (value < 0) {
													toast.error("Value cannot be negative");
													return;
												}
												if (value > part.currentStock) {
													toast.error("Pick quantity cannot exceed available quantity");
													return;
												}
												setParts(
													parts.map((_part: any) => {
														if (_part.value == part.value) {
															_part.qty = e.target.value;
														}
														return _part;
													})
												);

												//     update(index, {
												//     ...parts[index],
												//      qty: e.target.value ,
												//   })
											}}
										/>
									</div>
								</div>
							))}
						</div>
					</>
				)}

				<Controller
					name='pickNote'
					//rules={{ required: "Facility is required" }}
					control={control}
					render={({ field: { value, onChange } }) => (
						<Teaxtarea
							label='Notes'
							value={value}
							onChange={onChange}
							//required
							placeholder='Write Your Notes'
							error={errors.pickNote?.message as any}
						/>
					)}
				/>

				<hr className='border-gray-900 my-6' />
			</div>
			<div className='flex justify-end gap-2'>
				<Button type="submit" disabled={parts.length == 0 ? true : false}>Save</Button>
				<Button theme='secondary' onClick={() => {
					onCancel();
					formReset();
				}}>Cancel</Button>
			</div>


		</form>
	);
};

export default CreateStockpicking;
